"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    noWhiteSpace: 'No white spaces allowed',
    noWhiteSpaceExceptUnderscore: 'No whitespaces or special charaters (except underscore) allowed',
    noWhiteSpaceExceptUnderscoreAndColon: 'No whitespaces or special charaters (except underscore and colon) allowed',
    required: 'Required',
    unique: 'Already exists',
};
